module.exports = "<p-tree [style]=\"{'height':'500px'}\" [value]=\"userTreeNode\" selectionMode=\"single\" [(selection)]=\"selectedFile\"\r\n        (onNodeSelect)=\"nodeSelect($event)\" (onNodeUnselect)=\"nodeUnselect($event)\"></p-tree>\r\n<div style=\"margin-top:8px\">Selected Node: {{selectedFile ? selectedFile.label : 'none'}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/device/company_tree.html
// module id = ../../../../../src/app/page/device/company_tree.html
// module chunks = 1